// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculator-1"},"children":[{"tag":"path","attrs":{"id":"fil1","fill":"#fff","d":"M19 21V9H5V21H19Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5 3H19V9H5V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 3V21H5V3M19 3H5M19 3V9H5V3M14 9L14 21M10 9L10 21M5 13H19M5 17H19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calculator1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calculator-1',
    ref,
    icon: element,
  },
));

Calculator1Icon.displayName = 'Calculator1Icon';

export default Calculator1Icon;
